<template>
  <div class="work-bambuser">

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FUI%20blueprint%402x.webp?alt=media&token=f313628f-2617-4f32-879a-f7bdfb1840a5" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FDS%201.webp?alt=media&token=8a99f54a-7d4d-41db-8edd-8c3737950b6f" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FDS%202.webp?alt=media&token=3e6cb834-49aa-43c4-bb30-f79ddc57d77a" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FDS%203.webp?alt=media&token=45adf655-dc3d-46f0-8b3c-d4bbc2c135b1" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FDS%204.webp?alt=media&token=eda212eb-eba1-4430-bf68-f1008c540079" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesignsystem%2FDS%205.webp?alt=media&token=b6648251-6e58-4fd0-9daf-f5a3140c15d3" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-4">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FMob_Cards%402x.webp?alt=media&token=34a43b55-dc3f-4c05-b04d-425c881998c7" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-3">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FCard_Upload%402x.webp?alt=media&token=9df6bd7b-b96c-4bbc-a2e3-216b6c4cb9d3" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-2">
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FCards_Products%403x.webp?alt=media&token=7fd50c9f-2887-4fef-90c7-3d5de88cd2b4" alt=""></div>
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FCards_Products_WF%403x.webp?alt=media&token=0b3e7781-02fb-41e7-8564-1758a4258c31" alt=""></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-2">
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FChat%403x.webp?alt=media&token=5e49758a-d702-4dcd-b69c-eb330f2abbf3" alt=""></div>
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FChat_WF%403x.webp?alt=media&token=b60dcfcc-0857-4754-a86b-20c33faec38b" alt=""></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-2">
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FMob_Live%404x.webp?alt=media&token=f32f1dcb-5127-4a71-97e3-7fd556c479f3" alt=""></div>
        <div class="pad-1 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FMob_Live_WF%404x.webp?alt=media&token=16143d59-7163-4cd5-b731-e25e989e8f98" alt=""></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-4">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fcomponents%2FCard_Variants%403x.webp?alt=media&token=86187408-f915-41e0-9051-74395e68cb09" alt="">
      </div>
    </div>

    <div class="section-wrap app-l2-r2">
      <div class="grid-4 grid-mob-1 bg-light">
        <div class="l2 grid-2 pad-1 bs-bb bg-light">
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FNative%20-%20Login%403x.webp?alt=media&token=21e75290-1700-4ef0-84e1-74d1c0c51142" alt=""></div>
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FNative%20-%20All%20Shows%403x.webp?alt=media&token=56217e6d-495e-4fbf-ab38-55aab259eff5" alt=""></div>
        </div>
        <div class="bg-light"></div>
        <div class="bg-light"></div>
        <div class="r2 grid-2 pad-1 bs-bb bg-light">
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FNative%20-%20Show%403x.webp?alt=media&token=d361db2f-2876-4012-9ac6-fef68f106aa4" alt=""></div>
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FNative%20-%20Menu%403x.webp?alt=media&token=e3f45760-dab4-4f19-9ef4-b737bc4f86b3" alt=""></div>
        </div>
      </div>
    </div>

    <div class="section-wrap app-checkout">
      
      <div class="grid-3 grid-mob-1 bg-light">
        <div></div>
        <div class="pad-1 stream bs-bb bg-light">
          <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FApp%20-%20Stream%403x.webp?alt=media&token=a15490eb-5612-47bf-8a00-efd9a9066eb1" alt="">
        </div>
        <div></div>
      </div>

      <div class="app-l2-r2 grid-4 grid-mob-1 bg-light">
        <div class="l2 grid-2 pad-1 bs-bb bg-light">
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FApp%20-%20Shop%20all%403x.webp?alt=media&token=d2680fde-f218-4ed3-9b0c-9a0091c2f8b0" alt=""></div>
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FApp%20-%20Product%403x.webp?alt=media&token=540446e2-3ce7-408a-bbcd-9dd5e3e38304" alt=""></div>
        </div>
        <div></div>
        <div></div>
        <div class="r2 grid-2 pad-1 bs-bb bg-light">
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FApp%20-%20Cart%403x.webp?alt=media&token=f56a314f-b56d-4e5a-a846-dfd0e07c5ac5" alt=""></div>
            <div><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fapp%2FApp%20-%20Checkout%403x.webp?alt=media&token=96c3cf40-8b7b-4818-9694-c8d300aa8423" alt=""></div>
        </div>
      </div>
    </div> 

    <div class="section-wrap">
      <div class="grid-4 grid-mob-1">
        <img class="pad-2-pad-1 bs-bb w-100 bg-light d-f" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FWeb%20-%20mini%402x.webp?alt=media&token=cb955cdf-b71b-4adc-be1c-53d082767931" alt="">
        <img class="pad-2-pad-1 bs-bb w-100 bg-light d-f" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FWeb%20-%20products%402x.webp?alt=media&token=77427fca-909c-4036-8a08-22dfd37798ea" alt="">
        <img class="pad-2-pad-1 bs-bb w-100 bg-light d-f" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FWeb%20-%20hover%402x.webp?alt=media&token=e179b80c-8b3f-4580-8be8-ab9b3b6e7e08" alt="">
        <img class="pad-2-pad-1 bs-bb w-100 bg-light d-f" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FWeb%20-%20product%402x.webp?alt=media&token=6cc8e872-288b-425d-bccb-ec84fba6bc7b" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-4">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FPlayer%402x.webp?alt=media&token=827954f0-f810-413d-9642-245fb80ec37b" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FLive%20Studio%402x.webp?alt=media&token=c876e17e-c910-4636-a314-a19fca6bff01" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FStats%201%402x.webp?alt=media&token=d2cdb022-e1a1-47ad-bb25-407df130ff17" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light d-f pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FWeb%20-%20Start%402x.webp?alt=media&token=b5df58fe-006f-4453-87bf-b850d38f74d7" alt="">
      </div>
    </div>


    <div class="section-wrap">
      <div class="grid-2 bg-light long-split">
        <div class="pad-1 d-f"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FCase%20study%20-%201.webp?alt=media&token=f17f5eb3-2c1b-4ad7-a67b-a658a5649a58" alt=""></div>
        <div class="pad-1 d-f"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Fbambuser%2Fdesktop%2FCase%20study%20-%202.webp?alt=media&token=882ba86a-6a31-4a3f-badb-5470b0c94f6a" alt=""></div>
      </div>
    </div>



  </div>
</template>

<script>


export default {
  name: 'WorkBambuser',
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

.work-bambuser {
  .app-l2-r2 {
    .l2 {
      @include useMargin(padding-bottom);
    }
    .r2 {
      @include useMargin(padding-top);
    }
  }
  .app-checkout {
    .stream {
      // padding-bottom: 0;
      @include useMargin(padding-bottom);
    }
    .l2 {
      @include useMargin(padding-top);
      @include useMargin(padding-bottom);
      @media #{$desktop} {
        // padding-right: 20px;
      }
    }
    .r2 {
      @include useMargin(padding-top);
      @media #{$desktop} {
        // padding-left: 20px;
      }
    }
  }
}

</style>
